export const TabsListActionTypes = {
  valueChange: 'valueChange'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/base/useTabsList/useTabsList.types.js
// module id = 693
// module chunks = 0